const IssuerType = Object.freeze({
  GOVERNMENT: "GOVERNMENT",
  SEMI_GOVERNMENT: "SEMI_GOVERNMENT",
  CORPORATE: "CORPORATE",
});

export default IssuerType;
